// API Configuration File
// Update this file with your Hostinger domain

// Development (Local)
const API_URL_DEV = 'http://localhost:8000/api.php';

// Production (Hostinger)
const API_URL_PROD = 'https://alamcarerx.com/backend/api.php';

// Auto-detect environment
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? API_URL_PROD 
  : API_URL_DEV;

// Example usage in components:
// fetch(`${API_BASE_URL}?action=login`, { ... })
// fetch(`${API_BASE_URL}?action=products`, { ... })
